import { Component } from 'react';
import { logger } from '../utils/logger';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    logger.error('react-boundary', error, { componentStack: info?.componentStack });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen bg-[var(--color-paper-bg)] flex items-center justify-center p-4">
        <div className="bg-[var(--color-surface-elevated)] rounded-3xl shadow-xl p-8 w-full max-w-md border border-[var(--color-divider)] text-center">
          <div className="w-16 h-16 mx-auto bg-red-100 rounded-2xl flex items-center justify-center mb-4">
            <span className="text-3xl" role="img" aria-label="warning">!</span>
          </div>
          <h1 className="text-2xl font-bold text-ink-main mb-2">Something went wrong</h1>
          <p className="text-ink-light mb-6">
            The app hit an unexpected error. Reloading usually clears it up.
          </p>
          <button
            onClick={this.handleReload}
            className="w-full py-3 bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-semibold rounded-xl hover:from-purple-700 hover:to-indigo-700"
          >
            Reload app
          </button>
        </div>
      </div>
    );
  }
}
